import { Xhr } from 'hudl-base';

export default function promoteDynamicContent(comScoreId) {
    // fire Comscore dynamic tag
    self.COMSCORE && COMSCORE.beacon({c1: '2', c2: comScoreId});

    // get pageview candidate
    Xhr.instance.get('/api/v2/feedconsumer/comscore/pageview-candidate').done(result => result);
}
